import { BarChart3, Building2, Coins, Image, Languages, Palette, ScrollText, Plug, Share2, SlidersHorizontal, Sparkles, Users, type LucideIcon } from 'lucide-react';

/** One area of the settings: route, icon, label key and the permission that shows it (cosmetic, the server enforces). */
export interface SettingsSection {
  readonly key: string;
  readonly path: string;
  readonly icon: LucideIcon;
  /** i18n key of the short label (tab band and overview). */
  readonly labelKey: string;
  /** Shown only with this permission; absent means every member. */
  readonly permission?: string;
  /** Match the path exactly (`/settings/ai` must not stay active on `/settings/ai/usage`). */
  readonly end?: boolean;
}

/**
 * The settings areas in their one order (spec 10 §6): the tab band on wide screens and the overview list
 * `/settings` both render from here, so no area can be reachable from one and missing from the other.
 */
export const SETTINGS_SECTIONS: readonly SettingsSection[] = [
  { key: 'members', path: '/settings/members', icon: Users, labelKey: 'settings.nav.members', permission: 'members:manage' },
  { key: 'properties', path: '/settings/properties', icon: Building2, labelKey: 'settings.nav.properties' },
  { key: 'general', path: '/settings/general', icon: SlidersHorizontal, labelKey: 'settings.nav.general' },
  { key: 'media', path: '/settings/media', icon: Image, labelKey: 'settings.nav.media', permission: 'media:read' },
  { key: 'brand', path: '/settings/brand', icon: Palette, labelKey: 'settings.nav.brand' },
  { key: 'accounts', path: '/settings/accounts', icon: Share2, labelKey: 'settings.nav.accounts' },
  { key: 'languages', path: '/settings/languages', icon: Languages, labelKey: 'settings.nav.languages' },
  { key: 'ai', path: '/settings/ai', icon: Sparkles, labelKey: 'settings.nav.ai', permission: 'ai:run', end: true },
  { key: 'aiUsage', path: '/settings/ai/usage', icon: BarChart3, labelKey: 'settings.nav.aiUsage', permission: 'ai:run' },
  { key: 'billing', path: '/settings/billing', icon: Coins, labelKey: 'settings.nav.billing', permission: 'ai:run' },
  { key: 'integrations', path: '/settings/integrations', icon: Plug, labelKey: 'settings.nav.integrations' },
  { key: 'auditLog', path: '/settings/audit-log', icon: ScrollText, labelKey: 'settings.nav.auditLog', permission: 'audit:read' },
];

/** The sections the given permissions show, in their order. */
export function visibleSettingsSections(permissions: readonly string[]): SettingsSection[] {
  return SETTINGS_SECTIONS.filter((section) => !section.permission || permissions.includes(section.permission));
}
